var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"500"}},[_c('v-container',[_c('v-row',{attrs:{"no-gutters":"","align":"center"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }